export default __webpack_public_path__ + "static/media/ring_411.2bcb6ebf.gif";